module.exports = __webpack_public_path__ + "4437325c48089b05d0110eb37835c518.svg";